import { createActionGroup, emptyProps, props } from '@ngrx/store';

import * as fromGenerated from '../../_generated';

export type AdminUsersSortColumn = 'user' | 'role' | 'teammates' | 'groups';
export type AdminUsersSortDirection = 'asc' | 'desc';

export const AdminUsersActions = createActionGroup({
  source: 'AdminUsers',
  events: {
    'Load Users': emptyProps(),
    'Load Users Success': props<{ users: fromGenerated.AdminUserView[] }>(),
    'Load Users Failure': props<{ error: string }>(),

    'Set Sort': props<{
      column: AdminUsersSortColumn | null;
      direction: AdminUsersSortDirection;
    }>(),
    'Set Filter': props<{ filter: string }>(),
    // Lazy per-row expand payload for the table count-cell dropdowns
    // (teammates / groups lists for a user).
    'Load Dropdown Payload': props<{ userId: string }>(),
    'Load Dropdown Payload Success': props<{
      userId: string;
      payload: fromGenerated.UserDropdownPayloadView;
    }>(),
    'Load Dropdown Payload Failure': props<{
      userId: string;
      error: string;
    }>(),
    'Update User Role': props<{
      userId: string;
      role: fromGenerated.UserRole;
    }>(),
    'Update User Role Success': props<{ user: fromGenerated.AdminUserView }>(),
    'Update User Role Failure': props<{
      error: string;
      errorName: string | null;
    }>(),
  },
});
